import { render } from "./shopifyProdOri.vue?vue&type=template&id=ff27fcac&scoped=true"
import script from "./shopifyProdOri.vue?vue&type=script&lang=js"
export * from "./shopifyProdOri.vue?vue&type=script&lang=js"

import "./shopifyProdOri.vue?vue&type=style&index=0&id=ff27fcac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff27fcac"]])

export default __exports__